import React, { memo } from 'react';

const TitledComponent = ({ data }) => (
  <div className="truncate-text" title={data.description}>
    {data.description}
  </div>
);

export const Titled = memo(TitledComponent);
